'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RIGHT_ALIGNED = exports.LEFT_ALIGNED = exports.WidgetLocationProp = undefined;

var _react = require('react');

var _WidgetLocations = require('conversations-internal-schema/widget-location/constants/WidgetLocations');

var WidgetLocationProp = exports.WidgetLocationProp = _react.PropTypes.oneOf([_WidgetLocations.LEFT_ALIGNED, _WidgetLocations.RIGHT_ALIGNED]);
exports.LEFT_ALIGNED = _WidgetLocations.LEFT_ALIGNED;
exports.RIGHT_ALIGNED = _WidgetLocations.RIGHT_ALIGNED;